import { MonthlyPeriod } from "global";
import { useGetNetworkDashboardAsAdminQuery } from "../../../lib/apollo/graphql/generated";
import BoxWithShadow from "../../common/components/BoxWithShadow";
import CountCard from "../../common/components/CountCard";

interface NetworkMetadataBoxProps {
  period: MonthlyPeriod;
}

export default function NetworkMetadataBox({
  period,
}: NetworkMetadataBoxProps) {
  const { data } = useGetNetworkDashboardAsAdminQuery({
    variables: {
      year: period.year,
      month: period.month,
    },
  });

  const metadata = data?.getNetworkDashboardAsAdmin;

  return (
    <BoxWithShadow className="h-full w-1/6 flex-shrink-0 overflow-hidden">
      <div className="flex h-full flex-col gap-5 overflow-y-auto">
        <CountCard
          label="전체 사용자 수"
          count={metadata?.totalUserCount}
          unit="명"
          percentage={metadata?.previousMonthUserCountRate}
        />
        <CountCard
          label="활성 사용자 수"
          count={metadata?.totalActiveUserCount}
          unit="명"
          percentage={metadata?.previousMonthActiveUserCountRate}
        />
        <CountCard
          label="활성화율"
          count={metadata?.activeUserRate || 0}
          unit="%"
          percentage={metadata?.previousMonthActiveUserRate || 0}
        />
        <CountCard
          label="추천 수"
          count={metadata?.totalInviteCount}
          unit="건"
          percentage={metadata?.previousMonthInviteCountRate}
        />
        <CountCard
          label="평균 추천 수"
          count={metadata?.averageReferralCount}
          unit="건"
          percentage={metadata?.previousMonthAverageReferralCountRate}
        />
        <CountCard
          label="평균 추천 Depth"
          count={metadata?.averageReferralDepth}
          unit=" depth"
          percentage={metadata?.previousMonthAverageReferralDepthRate}
        />
        <CountCard
          label="평균 활동 기간"
          count={metadata?.averageActivePeriod}
          unit="개월"
          percentage={metadata?.previousMonthAverageActivePeriodRate}
        />
      </div>
    </BoxWithShadow>
  );
}
